<div class="breadcrumb-container d-flex fd-row jc-start ai-center">
  <button
    class="back-btn"
    mat-icon-button
    (click)="goBack()"
    *ngIf="showBackButton && links.length > 1"
  >
    <mat-icon>arrow_back</mat-icon>
  </button>

  <div
    *ngFor="let link of links; let i = index; let first = first; let last = last"
    class="d-flex jc-center ai-center"
  >
    <ng-container *ngIf="!last; else lastLabel">
      <ng-container *ngIf="!(first && disableFirstBreadcrumbLink); else firstLabel">
        <a
          matRipple
          class="breadcrumb-button"
          [routerLink]="link.route"
          [ngClass]="{ firstPart: first && !showBackButton }"
          ><span>
            {{ link.displayName }}
          </span></a
        >
      </ng-container>
      <ng-template #firstLabel>
        <span class="breadcrumb-button" [ngClass]="{ firstPart: first && !showBackButton }">
          {{ link.displayName }}
        </span>
      </ng-template>
      <mat-icon *ngIf="!last">chevron_right</mat-icon>
    </ng-container>

    <ng-template #lastLabel>
      <span class="breadcrumb-button" [ngClass]="{ firstPart: first }">{{ link.displayName }}</span>
    </ng-template>
  </div>
</div>
